<div class="container">
  <div class="icon">
    <div class="count">
      <span>
        {{badgeGroup.count}}
      </span>
    </div>
    <svg-icon style="height: 36px" [svgStyle]="{'width.px': 36, 'height.px': 36}" [src]="badgeGroup.badge.icon"></svg-icon>
  </div>
  <div class="label">
    {{badgeGroup.badge.name}}
  </div>
</div>
